export default __webpack_public_path__ + "assets/89e1f9da87cc688384005f63b9b448d9.jpg";